import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const Image = styled.img`
  width: 57px;
  height: 57px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  & svg {
    & path:last-child {
      fill: ${({ theme }) => theme.palette.grey.secondary};
    }
  }
`;

const CartItemImage = ({ image, name }) => (
  <Image src={image} alt={name ? `Image of ${name}` : "Product image"} />
);

CartItemImage.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
};

CartItemImage.defaultProps = {
  image: null,
  name: null,
};

export default CartItemImage;
